// extracted by mini-css-extract-plugin
module.exports = {"msnbcDailyBorder":"styles_msnbcDailyBorder__1x5R3"};